(function () {
  if (window.__discountoyeFilterCleanupLoaded) return;
  window.__discountoyeFilterCleanupLoaded = true;

  const normalize = value => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const compact = value => normalize(value).replace(/[^a-z0-9]+/g, '');
  const familyForPath = () => {
    const path = normalize(window.location.pathname);
    const slug = path.split('/').filter(Boolean).pop() || '';
    if (/ac-tv-home-appliances|^[a-z0-9-]+-brand$|globofilter-best-selling-products-index|^(above-rs-|below-rs-|rs-[0-9]|all-products$|products$)/.test(slug)) return 'mixed';
    if (/power-bank|powerbank/.test(slug)) return 'powerbank';
    if (/charger|chargers|charger-cables|charging-cables/.test(slug)) return 'charger';
    if (/washing-machine|washing-machines|washer/.test(slug)) return 'washer';
    if (/refrigerator|fridge/.test(slug)) return 'fridge';
    if (/air-condition|aircondition|aircon|(^|-)ac(-|$)/.test(slug)) return 'ac';
    if (/monitor/.test(slug)) return 'monitor';
    if (/led-tv|television|smart-tv|(^|-)tv($|-)/.test(slug)) return 'tv';
    if (/laptop|macbook|notebook/.test(slug)) return 'laptop';
    if (/tablet|ipad/.test(slug)) return 'mobile';
    if (/accessor|earbud|earphone|headphone|cable|cover|protector|watch/.test(slug)) return 'other';
    if (/mobile-phone|best-mobiles-under|best-mobile-phones|(^|-)phones?($|-)|smartphone|^[a-z0-9-]+-mobiles?$/.test(slug)) return 'mobile';
    return 'other';
  };
  function headingFor(filter) {
    const summary = filter.querySelector('summary, .mobile-facets__summary, .facets__summary');
    return normalize(summary ? summary.textContent : '');
  }
  function shouldShowFilter(heading, family) {
    const h = compact(heading);
    const isRam = h.includes('ram');
    const isStorage = h.includes('storage') || h.includes('internalmemory') || h === 'memory';
    const isProcessor = h.includes('processor') || h === 'cpu' || h.includes('generation');
    const isGraphics = h.includes('graphics') || h === 'gpu' || h.includes('videocard');
    const isScreenSize = h.includes('screensize') || h.includes('displaysize') || h.includes('inches') || h === 'size';
    const isAcCapacity = h.includes('ton') || h.includes('btu') || h.includes('coolingcapacity') || h.includes('accapacity') || h.includes('airconditionercapacity');
    const isChargerPower = h.includes('watt') || h.includes('chargingpower') || h.includes('poweroutput');
    const isConnector = h.includes('connector') || h.includes('chargingtype') || h.includes('porttype') || h.includes('usbtype') || h.includes('typec') || h.includes('compatibility');
    const isBatteryCapacity = h.includes('batterycapacity') || h.includes('mah') || (h === 'capacity' && family === 'powerbank');
    const isLaundry = h.includes('loadingtype') || h.includes('washingprogram') || h.includes('washprogram');
    const isApplianceCapacity = h === 'capacity' || h.includes('liter') || h.includes('litre') || h.includes('fridgecapacity') || h.includes('refrigeratorcapacity') || h.includes('washcapacity') || h.includes('appliancecapacity');
    if (isRam || isStorage) return ['mobile', 'laptop', 'mixed'].includes(family);
    if (isProcessor || isGraphics) return family === 'laptop' || family === 'mixed';
    if (isScreenSize) return family === 'tv' || family === 'monitor' || family === 'mixed';
    if (isAcCapacity) return family === 'ac' || family === 'mixed';
    if (isChargerPower || isConnector) return family === 'charger' || family === 'mixed';
    if (isBatteryCapacity) return family === 'powerbank' || family === 'mixed';
    if (isLaundry) return family === 'washer' || family === 'mixed';
    if (isApplianceCapacity) return family === 'fridge' || family === 'washer' || family === 'mixed';
    return true;
  }
  function setDisplay(row, value) { if (row.style.display !== value) row.style.display = value; }

  function cleanFilters() {
    const family = familyForPath();
    document.querySelectorAll('.js-filter').forEach(function (filter) {
      const heading = headingFor(filter);
      const h = compact(heading);
      filter.classList.toggle('do-category-filter-hidden', !shouldShowFilter(heading, family));
      filter.setAttribute('data-discountoye-filter-family', family);
      if (h.includes('ram')) {
        Array.from(filter.querySelectorAll('.facets__item, .mobile-facets__item')).forEach(function (row) {
          const label = row.querySelector('.facet-checkbox__text-label');
          if (!label) return;
          const value = normalize(label.textContent);
          const matches = Array.from(value.matchAll(/\d+(?:\.\d+)?\s*gb/gi));
          const valid = matches.length === 1 && !/\b(storage|internal memory)\b/i.test(value);
          row.classList.toggle('lx-filter-hidden', !valid);
          setDisplay(row, valid ? '' : 'none');
          if (valid) label.textContent = matches[0][0].replace(/\s+/g, '').toUpperCase();
        });
      }
      if (h.includes('storage') || h.includes('internalmemory')) {
        const rows = Array.from(filter.querySelectorAll('.facets__item, .mobile-facets__item'));
        const groups = new Map();
        rows.forEach(function (row) {
          const label = row.querySelector('.facet-checkbox__text-label');
          const input = row.querySelector('input[type="checkbox"]');
          if (!label || !input) return;
          const match = normalize(label.textContent).match(/(\d+(?:\.\d+)?)\s*(gb|tb)/i);
          if (!match) { row.classList.add('lx-filter-hidden'); setDisplay(row, 'none'); return; }
          const capacity = String(Number(match[1])) + match[2].toUpperCase();
          if (!groups.has(capacity)) groups.set(capacity, []);
          groups.get(capacity).push({ row, label, input });
        });
        groups.forEach(function (items, capacity) {
          const visible = items.find(item => item.input.checked) || items[0];
          const paramName = visible.input.name;
          if (!items.every(item => item.input.name === paramName)) {
            items.forEach(item => { setDisplay(item.row, ''); item.row.classList.remove('lx-filter-hidden'); });
            return;
          }
          visible.label.textContent = capacity;
          visible.row.classList.remove('lx-filter-hidden');
          setDisplay(visible.row, '');
          if (items.length > 1) {
            visible.input.dataset.storageGroupValues = JSON.stringify(items.map(item => item.input.value));
            visible.input.dataset.storageGroupParam = paramName;
          } else {
            delete visible.input.dataset.storageGroupValues;
            delete visible.input.dataset.storageGroupParam;
          }
          items.forEach(item => {
            if (item !== visible) { item.row.classList.add('lx-filter-hidden'); setDisplay(item.row, 'none'); }
          });
        });
      }
    });
    // Prefer the dedicated custom.filter_* metafield filters over legacy Product option filters.
    if (['mobile', 'laptop', 'mixed'].includes(family)) {
      ['ram', 'storage'].forEach(function (kind) {
        const matching = Array.from(document.querySelectorAll('.js-filter')).filter(function (filter) {
          const heading = compact(headingFor(filter));
          return kind === 'ram' ? heading.includes('ram') : (heading.includes('storage') || heading.includes('internalmemory'));
        });
        if (matching.length < 2) return;
        const preferred = matching.find(function (filter) {
          const source = compact(filter.id + ' ' + Array.from(filter.querySelectorAll('input')).map(function (input) { return input.name || ''; }).join(' '));
          return source.includes('customfilter' + kind);
        });
        if (preferred) matching.forEach(function (filter) {
          const hide = filter !== preferred;
          filter.classList.toggle('do-category-filter-hidden', hide);
          filter.setAttribute('data-discountoye-duplicate-filter', hide ? 'hidden' : 'preferred');
        });
      });
    }
  }
  document.addEventListener('click', function (event) {
    const row = event.target.closest('.facets__item, .mobile-facets__item');
    if (!row) return;
    const input = row.querySelector('input[data-storage-group-values]');
    if (!input) return;
    let values;
    try { values = JSON.parse(input.dataset.storageGroupValues || '[]'); } catch (error) { return; }
    const paramName = input.dataset.storageGroupParam || input.name;
    if (!paramName || values.length < 2) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const params = new URLSearchParams(window.location.search);
    const current = params.getAll(paramName).flatMap(value => value.split(',')).filter(Boolean);
    const selected = values.some(value => current.includes(value));
    const next = new Set(current);
    values.forEach(value => { if (selected) next.delete(value); else next.add(value); });
    params.delete(paramName);
    next.forEach(value => params.append(paramName, value));
    params.delete('page');
    const query = params.toString();
    window.location.assign(window.location.pathname + (query ? '?' + query : ''));
  }, true);
  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; cleanFilters(); });
  }
  const style = document.createElement('style');
  style.textContent = '.do-category-filter-hidden{display:none!important}';
  document.head.appendChild(style);
  cleanFilters();
  new MutationObserver(schedule).observe(document.body, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style']
  });
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('popstate', schedule);
})();